<template>
  <button class="button-cta" @click="toggleAlertsModal()" v-if="settings.socialLinks.whatsapp">
    <span class="play-icon">
      <img :src="`/assets/img/logo-whatsapp.png`" />
    </span>
    Get Deal Alerts
  </button>
  
</template>

<script setup lang="ts">
import settings from "@/settings";
import { globalStore } from '@/stores/globalStore'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'

const $globalStore = globalStore()
const toggleAlertsModal = () => {
  $globalStore.setShowModalDealAlerts(true)

  ga.event('click', { 'event_category': 'getalerts', 'event_label': "start" })
  clicky.log('Get Alerts: START', 'click')

};
</script>
